import { useList, useGetList, ListContextProvider } from 'react-admin'
import PropTypes from 'prop-types'
import ComponentWrapper from './ComponentWrapper'
import TableLayout from './TableLayout'

export default function OfferAccepted({ userId }) {
  const { data, isPending } = useGetList('quote-requests', {
    pagination: { page: 1, perPage: 1000 },
    filter: {
      status: 'Offer accepted',
      mainUser: userId,
      archived: false,
      'tags.tagName': 'DISTRO',
    },
  })

  const listContext = useList({
    data,
    isPending,
    perPage: 10,
  })

  // Dont show section if data empty
  if (isPending || data === undefined || data.length === 0) {
    return <></>
  }

  return (
    <ComponentWrapper title={'Offer accepted'}>
      <ListContextProvider value={listContext}>
        <TableLayout userId={userId} />
      </ListContextProvider>
    </ComponentWrapper>
  )
}

OfferAccepted.propTypes = {
  userId: PropTypes.string,
}
